import { useRef } from "react";

import { isImageUpload } from "@hightouch/lib/llm/files/types";
import { useInView } from "motion/react";

import { useAmpLibraryFileQuery } from "src/graphql";

/** An uploaded Library file, read once `ref`'s element nears the screen, and kept only when it's an image. */
export function useImageUpload(fileId: string) {
  const ref = useRef<HTMLDivElement>(null);
  const isNearViewport = useInView(ref, { margin: "200px" });
  const { data } = useAmpLibraryFileQuery(
    { id: fileId },
    { enabled: isNearViewport },
  );
  const file = data?.ampFile;
  return {
    ref,
    image: file?.upload && isImageUpload(file.upload) ? file : null,
  };
}
